require('./sctToaster.scss');

const sctToaster = angular.module('app.sct.sctToaster', []);

sctToaster.component('sctToaster', {
  controller: ['sctToasterService', controller],
  controllerAs: 'vm',
  template: require('./sctToaster.html')
});

function controller(sctToasterService) {
  let vm = this;
  vm.toaster = sctToasterService;
}

export default sctToaster;


// WEBPACK FOOTER //
// ./src/components/sct/sctToaster/sctToaster.js